"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JudgeOffset = exports.FarLineY = exports.FarLineZ = exports.LaneCenterXs = exports.LaneWidth = exports.LaneBottomY = exports.LaneInfY = exports.CenterX = exports.LayerHeight = exports.LayerWidth = void 0;
exports.LayerWidth = 1280;
exports.LayerHeight = 720;
exports.CenterX = exports.LayerWidth / 2;
exports.LaneInfY = -5;
exports.LaneBottomY = exports.LayerHeight * 0.85;
exports.LaneWidth = 0.12 * exports.LayerWidth;
exports.LaneCenterXs = [];
for (let i = -3; i < 4; i++) {
    exports.LaneCenterXs.push(exports.CenterX + i * exports.LaneWidth);
}
exports.FarLineZ = 20;
exports.FarLineY = (exports.LaneBottomY - exports.LaneInfY) / exports.FarLineZ + exports.LaneInfY;
exports.JudgeOffset = {
    /**
     * single
     * flick (pointer down time)
     * long start
     */
    typeA: (offset) => {
        const off = (offset * 1000) | 0;
        if (off < -200)
            return undefined;
        if (off < -116 || off > 133)
            return "miss";
        if (off < -100 || off > 116)
            return "bad";
        if (off < -83 || off > 100)
            return "good";
        if (off < -33 || off > 50)
            return "great";
        return "perfect";
    },
    /**
     * long end
     * long end flick (point move out time)
     */
    typeB: (offset) => {
        const off = (offset * 1000) | 0;
        if (off < -200)
            return undefined;
        if (off < -133 || off > 150)
            return "miss";
        if (off < -116 || off > 133)
            return "bad";
        if (off < -100 || off > 116)
            return "good";
        if (off < -50 || off > 67)
            return "great";
        return "perfect";
    },
    /**
     * slide start
     * slide end
     */
    typeC: (offset) => {
        const off = (offset * 1000) | 0;
        if (off < -200)
            return undefined;
        if (off < -116 || off > 200)
            return "miss";
        if (off < -100)
            return "bad";
        if (off < -83)
            return "good";
        if (off < -33)
            return "great";
        return "perfect";
    },
    /**
     * slide end flick (pointer move out time)
     */
    typeD: (offset) => {
        const off = (offset * 1000) | 0;
        if (off < 0)
            return undefined;
        if (off > 100)
            return "miss";
        return "perfect";
    },
    /**
     * slide among
     */
    typeE: (offset) => {
        const off = (offset * 1000) | 0;
        if (off < 0)
            return undefined;
        if (off > 200)
            return "miss";
        return "perfect";
    },
    flickOutTime: 0.1,
    flickOutDis: 40,
};
//# sourceMappingURL=Constants.js.map